import { createSelector } from 'reselect';
import { getProfileMedia } from './getProfileMedia';

export const getCoverImages = createSelector(getProfileMedia, (items) => {
	return (items?.venue || [])
		.filter((i) => !!i)
		.map((item, index) => {
			const { width, height } = item;
			const align = items.venueAlign[index];
			const edge = index === 0 ? 1.5 : 1.2;
			const axis = width / height > edge ? 'horizontal' : 'vertical';

			return {
				src: item.url.split('=')[0],
				position: align === 'center' ? undefined : align,
				specId: 1,
				forceVisibility: true,
				mediaId: item.id,
				width,
				height,
				axis,
			};
		});
});
